// extracted by mini-css-extract-plugin
module.exports =  {"close":"_2787e5dfdf--close--xkh6d"};